import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import RedirectIfIncompleteRegistration from '../redirectIfIncompleteRegistration';

export type ProtectedRouteProps = {
  children: React.ReactNode;
};

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth();
  
  // Mostra nada enquanto verifica autenticação
  if (loading) {
    return null;
  }
  
  // Redireciona para login se não estiver autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // Wrap com o componente que verifica se o registro está completo
  return <RedirectIfIncompleteRegistration>{children}</RedirectIfIncompleteRegistration>;
}

export default ProtectedRoute;